// src/pages/offerformsubmissions.js
import React, { useState, useEffect } from "react";

const WORKER_URL = "https://reflex-backend.alfaoir1.workers.dev";

export default function OfferFormSubmissions() {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [retryCount, setRetryCount] = useState(0);

  const fetchSubmissions = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${WORKER_URL}/offer-forms`);
      const data = await res.json();
      if (!data.success) throw new Error(data.error || "Failed to load submissions");
      setSubmissions(data.submissions);
    } catch (err) {
      console.error(err);
      setError("Connection to backend failed. Retrying...");
    } finally {
      setLoading(false);
    }
  };

  // Retry logic — same pattern as businessforms.js
  useEffect(() => {
    fetchSubmissions();
  }, []);

  useEffect(() => {
    if (error && retryCount < 5) {
      const timer = setTimeout(() => {
        setRetryCount((c) => c + 1);
        fetchSubmissions();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [error, retryCount]);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this submission?")) return;
    try {
      const res = await fetch(`${WORKER_URL}/offer-forms/${id}`, { method: "DELETE" });
      const data = await res.json();
      if (data.success) {
        setSubmissions((prev) => prev.filter((s) => s._id !== id));
      }
    } catch (err) {
      console.error(err);
      alert("Failed to delete submission.");
    }
  };

  return (
    <div style={{ padding: "40px 24px", fontFamily: "-apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif", maxWidth: 1100, margin: "0 auto" }}>
      <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8 }}>$47 Website Offer Submissions</h1>
      <p style={{ color: "#666", marginBottom: 32 }}>{submissions.length} total submissions</p>

      {loading && <p>Loading submissions...</p>}
      {error && <p style={{ color: "#d6336c" }}>{error}</p>}

      {!loading && !error && submissions.length === 0 && (
        <p style={{ color: "#888" }}>No submissions yet.</p>
      )}

      {!loading && submissions.length > 0 && (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}>
            <thead>
              <tr style={{ textAlign: "left", borderBottom: "2px solid #eee" }}>
                <th style={{ padding: "10px 12px" }}>Name</th>
                <th style={{ padding: "10px 12px" }}>Phone</th>
                <th style={{ padding: "10px 12px" }}>Email</th>
                <th style={{ padding: "10px 12px" }}>Website</th>
                <th style={{ padding: "10px 12px" }}>Note</th>
                <th style={{ padding: "10px 12px" }}>Submitted</th>
                <th style={{ padding: "10px 12px" }}></th>
              </tr>
            </thead>
            <tbody>
              {submissions.map((s) => (
                <tr key={s._id} style={{ borderBottom: "1px solid #f0f0f0" }}>
                  <td style={{ padding: "10px 12px", fontWeight: 600 }}>{s.name}</td>
                  <td style={{ padding: "10px 12px" }}>{s.phone}</td>
                  <td style={{ padding: "10px 12px" }}>{s.email}</td>
                  <td style={{ padding: "10px 12px" }}>{s.website || "—"}</td>
                  <td style={{ padding: "10px 12px", maxWidth: 220 }}>{s.note || "—"}</td>
                  <td style={{ padding: "10px 12px", color: "#888" }}>
                    {new Date(s.submittedAt).toLocaleString()}
                  </td>
                  <td style={{ padding: "10px 12px" }}>
                    <button
                      onClick={() => handleDelete(s._id)}
                      style={{
                        background: "#fee",
                        color: "#c0392b",
                        border: "none",
                        borderRadius: 6,
                        padding: "6px 12px",
                        cursor: "pointer",
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}